import { dataCheckApi } from "@/shared/apis";

export async function validatePhoneNumber(
    phoneNumber: string,
    phoneType: string,
    regionCode: string = null,
): Promise<boolean> {
    const isMobileType = phoneType === "007";

    if (!phoneNumber) {
        return true;
    }
    try {
        return await dataCheckApi.queryCheckPhoneNumber(phoneNumber, regionCode, isMobileType);
    } catch (e) {
        return false;
    }
}
